<!--
 * @Author: linsc
 * @Date: 2023-04-04 10:47:45
 * @LastEditTime: 2023-04-13 16:01:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kcop-smcr\src\business\businessFile\GUOXIN\M0002\QS421_uploadImg.vue
-->
<template>
  <div class="QS421-form-print-page">
    <form-print-list ref ="uploadImgView" :bizData.sync = 'bizData' :historyData = "historyData" :oppBusiData = "oppBusiData" :isShowNav="true"
      :maxApptStatus="4" :isDisabled="isDisablePage" @on-next-click="next">
      <div class="infoModule">
        <h3 class="means-head-tit"> 
          <img src="@img/oldCode/title-icon.png"/>
          <span class="title__txt">
            账户信息
          </span>
        </h3>
        <div class="update_main">
          <div class="item">
            <el-form :model="{}">
              <k-input id="CUST_CODE" label="客户代码" placeholder="系统自动生成" :value.sync="CUST_CODE"  validtype="length[1,256]|on-change" disabled />
            </el-form>
          </div>
        </div>
      </div>
    </form-print-list >
  </div>
</template>

<script>
import formPrintList from "@/components/imageNode/formPrintList.vue";
import kInput from "@/components/baseUI/kInput";


export default {
  data () {
    return {
      CUST_CODE:"",
    };
  },
  components: {
    formPrintList,
    kInput
  },
  props: ["bizData", "historyData", "oppBusiData", "groupDatas", "busiCode", "isDisablePage"],
  mounted () {
    this.CUST_CODE = _.get(this.historyData,"BIZ_DATA.NEW_CUST_CODE");
  },
  beforeDestroy (){
    // this.$emit("remove-flow-tip", "M0002SignDownLoad");
  },
  methods: {
    pageActivated (_this){
      _this.hideFooter(false);
    },
    validate (_this) {
      let that = _this.$refs.QS421_uploadImg;
      return that.$refs.uploadImgView.validate().then(flag=>{
        return flag;
      });
    },
    //下一步时，保存数据.
    beforeSave (_this, params, baseData) {
      // let that = _this.$refs.QS421_uploadImg;
      // let SIGN_INFO =  that.$refs.uploadImgView.getData() ;

      // if(_.isEmpty(params.SIGN_INFO)){
      //     params.SIGN_INFO = {};
      // }
      // Object.assign(params, {
      //     SIGN_INFO: SIGN_INFO
      // });
    },
    next () {
      this.$emit("on-next-click");
    }
  }
    

};
</script>

<style lang="less" scoped>
@import "~@/styles/less/variable.less";

.QS421-form-print-page{
  .infoModule{
    background: #fff;
    height: 160px;
    padding: 24px;
    background: #ffffff;
    border-radius: 5px;
    margin-bottom: 2px;
  }
  // .means-head-tit {
  //   background-color: #F7F8F9;
  //   height: .50rem;
  //   line-height: .50rem;
  //   // padding: 0 .rem;
  //   margin-bottom: .24rem;
  //   font-size: .18rem;
  //   position: relative;
  //   .fontsize-title-small();
  //   padding: .08rem .4rem .08rem .08rem;
  //   display: flex;
  //   align-items: center;
  //   img{
  //     width: 12px;
  //     height: 12px;
  //   }
  // }
  .self-normalInput{
    width: 41%;
    /deep/.el-form-item__label{
      width: 2.1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/business/businessFile/QS421/QS421_formPrint.vue